import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { HEADER_PRIMARY_NAV } from "@/lib/nav";
import Logo from "@/components/Logo";
import { T } from "@/constants/testIds";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid={T.header}
      className="sticky top-0 z-40 bg-background/90 backdrop-blur-2xl border-b border-border/70 shadow-[0_1px_0_rgba(15,23,42,0.03)]"
    >
      <div className="container-editorial flex items-center justify-between gap-6 h-[84px]">
        <Link data-testid={T.logoLink} to="/" className="shrink-0 transition-opacity hover:opacity-85" aria-label="Anant Jeevan — Home">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-7" aria-label="Primary">
          {HEADER_PRIMARY_NAV.map((item) => (
            <NavLink
              key={item.slug}
              to={item.to}
              data-testid={T.navLink(item.slug)}
              className={({ isActive }) => `nav-link ${isActive ? "nav-link-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center shrink-0">
          <Link data-testid={T.ctaDiscoverEternal} to="/eternal-life" className="btn-gold !py-2.5 !px-5 text-[12px]">
            Discover Eternal Life
          </Link>
        </div>

        <button
          data-testid={T.mobileMenuToggle}
          className="lg:hidden p-2 -mr-2 text-ink"
          aria-label="Open menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div data-testid={T.mobileMenu} className="lg:hidden border-t border-border bg-background shadow-xl">
          <div className="container-editorial py-5 flex flex-col">
            {HEADER_PRIMARY_NAV.map((item) => (
              <Link
                key={item.slug}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={T.navLink(`m-${item.slug}`)}
                className="group flex items-center justify-between py-3.5 border-b border-border/60 last:border-0 font-serif text-xl text-ink"
                style={{ fontWeight: 500 }}
              >
                {item.label}
                <ArrowRight className="h-4 w-4 text-gold opacity-0 -translate-x-1 transition-[opacity,transform] duration-200 group-hover:opacity-100 group-hover:translate-x-0" />
              </Link>
            ))}
            <Link
              data-testid={T.ctaDiscoverEternal + "-mobile"}
              to="/eternal-life"
              className="btn-gold mt-5 justify-center"
              onClick={() => setOpen(false)}
            >
              Discover Eternal Life
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
